import './FilterProp.css';
import React, {useEffect, useState} from 'react';
import {decode} from 'html-entities';
import FilterPropValue from '../filterPropValue/FilterPropValue';

function FilterProp(props) {
  // Текст поиска и значения фильтра приводим к одному виду перед сравнением
  function normalizeSearchText(value) {
    return decode(String(value || ''))
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
  }

  // Функция проверки вхождений, предварительно разбив значения
  function isMatchedBySearch(value, searchText) {
    const haystack = normalizeSearchText(
        `${value.VALUE || ''} ${value.VALUE_EN || ''}`);
    const searchParts = normalizeSearchText(searchText).split(' ').filter(Boolean);
    const haystackParts = haystack.split(' ').filter(Boolean);

    if (!searchParts.length) return true;

    return searchParts.every((searchPart) =>
      haystack.includes(searchPart) ||
      haystackParts.some((haystackPart) => haystackPart.includes(searchPart))
    );
  }

  const [values, setValues] = useState([]);
  // признак показа значений из настроек - по умолчанию
  // смена на основании выбора пользователя
  const [showValues, setShowValue] = useState(props.DISPLAY_EXPANDED === 'Y');
  // признак показа всех значений - по умолчанию
  const [showAllValues, setShowAllValues] = useState(false);
  const [searchValue, setSearchValue] = useState(''); // хранит текущий текст, введённый пользователем в поле поиска

  useEffect(() => {
    if (!Array.isArray(props.VALUES) || !props.VALUES.length) setValues([]);
    else {
      let filteredValues = props.VALUES.filter(
          value => Number(value.ELEMENT_COUNT) > 0 ||
              (Number(value.ELEMENT_COUNT) <= 0 && value.CHECKED === true));

      setValues(filteredValues);
    }

    setSearchValue('');
    setShowAllValues(false);
  }, [props.VALUES]);

  // количестко значений для показа по умолчанию
  const defaultDisplayValueCount = Number(props.ROWS) || values.length;

  // Нормализуем введённый текст один раз, чтобы не делать это повторно
  const normalizedSearchValue = normalizeSearchText(searchValue);
  // Если есть поисковый запрос - фильтруем, иначе берём все значения
  const searchedValues = normalizedSearchValue.length
      ? values.filter((value) => isMatchedBySearch(value, normalizedSearchValue))
      : values;

  // количестко значений для показа на основании выбора пользователя показа всех значений и по умолчанию
  const displayValueCount = normalizedSearchValue.length || showAllValues
      ? Number(searchedValues.length)
      : defaultDisplayValueCount;

  const canToggleAllValues = defaultDisplayValueCount < Number(values.length);
  const visibleValues = searchedValues.slice(0, displayValueCount);

  return (
      <div key={props.XML_ID}
           className={`filter-box ${showValues ? 'active' : ''}`}>
        <div className="filter-box__title"
             onClick={() => (setShowValue(!showValues))}>
          {props.NAME}
        </div>
        {
          showValues ?
              <div className={`filter-box__container`}>
                {
                  canToggleAllValues ?
                    <label className="relative block mt-4">
                      <span className='pointer-events-none absolute top-[13px] left-[12px]'>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4">
                          <use
                            href="/assets/images/sprite-icons.svg?v=db581922b9fff7dda0457cdac28c0743#search-icon"></use>
                        </svg>
                      </span>
                      <input
                        type="text"
                        className="w-full h-11 pl-9 pr-8 border border-solid border-[#d7d8e0] rounded-[8px] bg-white text-[14px] leading-normal text-[#333] placeholder:text-[#9b9fad]"
                        value={searchValue}
                        onChange={(event) => setSearchValue(event.target.value)}
                        placeholder={props.messages['CT_BCSF_FILTER_SEARCH']}/>
                        {searchValue.length ? (
                          <span className="absolute right-3 top-[14px] scale-[0.8]"
                                onClick={() => setSearchValue('')}
                                aria-label="Clear search">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 min-w-4 cursor-pointer">
                              <use href="/assets/images/sprite-icons.svg?v=db581922b9fff7dda0457cdac28c0743#close-icon"></use>
                            </svg>
                          </span>
                        ) : <></>}
                    </label> :
                    <></>
                }
                <ul className="filter-items-list">
                  {
                    visibleValues.length ?
                      visibleValues.map((value) => {
                        return <FilterPropValue key={value.FACET_VALUE}
                                                {...value}
                                                  notAsync={props.NOT_ASYNC &&
                                                      props.NOT_ASYNC === true}
                                                  onChange={props.onChange}/>;
                        }) :
                        <></>
                  }
                </ul>
                {
                  canToggleAllValues && !normalizedSearchValue.length ?
                      <span className="all-parameters-link"
                            onClick={() => (setShowAllValues(!showAllValues))}>
                        {
                          showAllValues ?
                              props.messages['CT_BCSF_FILTER_NOT_ALL'] :
                              props.messages['CT_BCSF_FILTER_ALL']
                        }
                      </span> :
                      <></>
                }
              </div> :
              <></>
        }
      </div>
  );
};

export default FilterProp;